/**
 * Return a not NaN number Aka number or default
 *
 * @param {number} value
 * @param {number} defaultValue
 * @returns {number}
 */
const number_ = (value, defaultValue = 0) => (Number.isNaN(value) ? defaultValue : value);
export default number_;
